import { FaUser } from "react-icons/fa";
import { FaRegCalendarAlt } from "react-icons/fa";
import BlogItemStyleWrapper from "./BlogItem.style";
import { useNavigate } from "react-router-dom";

const BlogItem = ({ thumbnail, title, timeStamp, author, excerpt }) => {

  const navigate = useNavigate();

  const navigateTo = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  }

  return (
    <BlogItemStyleWrapper className="single_blog_item">
      <div className="blog_thumb">
        <p onClick={() => navigateTo("/post")}>
          <img src={thumbnail} alt="blog" />
        </p>
      </div>
      <div className="blog_content">
        <div className="blog_meta">
          <span className="author" ><FaUser />{author}</span>
          <span className="time_stamp"><FaRegCalendarAlt />{timeStamp}</span>
        </div>

        <p className="blog_title" onClick={() => navigateTo("/post")}>
          {" "}
          {title}
        </p>
        <p className="blog_description">{excerpt} </p>
        <div className="blog_footer">
          <div className="read_more_btn">
            <p href="/post" onClick={() => navigateTo("/post")}> Read more</p>
          </div>
        </div>
      </div>
    </BlogItemStyleWrapper>
  );
};

export default BlogItem;
